import type { TrapGroup } from '@features/regional-overview/digital-traps/domain';
import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewDigitalTrapsProperties } from 'querys/regional-overview/regional-overview.query.models';
import { isAllOrEmpty } from './builders.utils';

const readTrapGroups = (context?: Record<string, unknown>): TrapGroup[] => {
  const raw = context?.trapGroups;
  return Array.isArray(raw) ? (raw as TrapGroup[]) : [];
};

export const buildTrapGroupsFilter = (): Filter =>
  buildFilter<RegionalOverviewDigitalTrapsProperties>({
    type: RegionalOverviewFilterType.GROUPS,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: false,
    getValues: (_feature, context) => readTrapGroups(context).map(trapGroup => trapGroup.title),
    matches: (feature, value) => {
      if (isAllOrEmpty(value)) return true;
      const groupName = feature.properties?.group?.name;
      if (!groupName) return false;
      return (value as string[]).includes(groupName);
    }
  });
